import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../styles/success.scss';

function Success() {
  const { t, i18n } = useTranslation();
  const service = useSelector((state) => state.service);
  const history = useHistory();

  if (!service.success) {
    history.push('/');
  }
  // Ensure moment uses current language for month names
  moment.locale(i18n.resolvedLanguage || 'sv');

  return (
    <div className="container success-container">
      <h1>
        {service.event
          ? t('success_thanks', 'Thanks!')
          : t('booking_success_title', 'Du har bokat en tid')}
      </h1>
      {service.event ? (
        <p>{t('success_email_details', 'You will receive more details via email shortly.')}</p>
      ) : (
        <>
          <p className="details m-0 p-0 mt-3 ">{`${
            service?.confirmedUser?.address?.value ??
            service?.user?.address?.value ??
            service?.shop?.address
          }, ${
            service?.confirmedUser?.address?.postcode ??
            service?.user?.address?.postcode ??
            service?.shop?.postcode
          }`}</p>
          <p className="details">
            {moment(service?.confirmedBooking?.date ?? service?.booking?.date).format('D MMMM') +
              ', ' +
              (service?.confirmedBooking?.service_slot_name ?? service?.booking?.service_slot_name)}
          </p>
          <div className="line" />
          <p className="info">
            {t(
              'booking_success_email_details',
              'Vi har även skickat en bekräftelse med detaljer och mer info till din e-postadress.'
            )}
          </p>
        </>
      )}
    </div>
  );
}

export default Success;
